module.exports = __webpack_public_path__ + "img/bubble-heart.fc16ecfc.svg";